<template>
  <div>
    <b-row>
      <b-col>
        <div class="mt-3">
          <b-form-group
            id="input-group-1"
            label="Pilih Nomor untuk CS AI"
            label-for="input-2"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <v-select
              id="input-2"
              v-model="formData.phone_number"
              name="input-phone-number"
              :options="numberOptions"
              placeholder="Pilih nomor disini"
              label="phone_number"
            />
          </b-form-group>
          <b-form-group
            id="switch 1"
            class="mt-3"
            label="Pengaturan Tambahan"
            label-for="switch"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <div class="flex d-none border mb-1 p-1 rounded-md items-center justify-between">
              <div>
                CS AI off Ketika Balas Manual <b-icon
                  id="popover-target"
                  class="cursor-pointer text-[#08A0F7]"
                  icon="info-circle"
                />
                <b-popover
                  target="popover-target"
                  triggers="hover"
                  placement="top"
                  custom-class="custom-popover"
                >
                  <div class="font-semibold mb-1">
                    Jadwal akan nonaktif
                  </div>
                </b-popover>
              </div>
              <b-form-checkbox
                id="switch-1"
                v-model="formData.is_off_when_manually"
                switch
              />
            </div>
            <div class=" border p-1 rounded-md">
              <div class="flex items-center justify-between">
                <div>
                  Setting Waktu CS AI
                </div>
                <b-form-checkbox
                  id="switch-2"
                  v-model="setCsTime"
                  switch
                />
              </div>
              <div
                v-show="setCsTime"
                class="border mt-1 p-1 rounded-md"
              >
                <b-form-group
                  id="input-group-custom-day-select"
                  label="Atur Hari CS"
                  label-for="custom-day-select-trigger"
                  label-class="mb-1 text-[14px] font-medium leading-none tracking-normal align-middle"
                >
                  <div class="custom-day-select position-relative">
                    <div
                      id="custom-day-select-trigger"
                      class="form-control d-flex justify-content-between align-items-center cursor-pointer"
                      @click="toggleDayDropdown"
                    >
                      <span>{{ formattedSelectedDaysText || 'Pilih Hari' }}</span>
                      <b-icon :icon="showDayDropdown ? 'chevron-up' : 'chevron-down'" />
                    </div>
                    <div
                      v-if="showDayDropdown"
                      class="custom-day-select-dropdown position-absolute w-100 list-group shadow-sm"
                      style="z-index: 1000; background-color: white;"
                    >
                      <div
                        v-for="option in days"
                        :key="option.id"
                        class="list-group-item list-group-item-action d-flex align-items-center cursor-pointer custom-v-select-option"
                        :class="{
                          'active-day-option': isDaySelected(option),
                          'disabled-day-option': isDayOptionDisabled(option) && !isDaySelected(option),
                          'setiap-hari-option': option.name === 'Setiap Hari'
                        }"
                        @click="selectDay(option)"
                      >
                        <b-form-checkbox
                          :checked="isDaySelected(option)"
                          :disabled="isDayOptionDisabled(option) && !isDaySelected(option)"
                          class="mr-2 pointer-events-none"
                        />
                        <span>{{ option.name }}</span>
                      </div>
                    </div>
                  </div>
                </b-form-group>
                <div
                  class="grid gap-2 grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2"
                >
                  <div
                    v-for="(day, index) in selectedDays"
                    :key="index"
                    class="border rounded-md p-1 w-full"
                  >
                    <b-row class="mb-1">
                      <b-col class="text-[#333333]">
                        {{ day.name }}
                      </b-col>
                      <b-col>
                        <b-form-checkbox
                          :id="`checkbox-${index}`"
                          v-model="day.fullDay"
                          name="checkbox-1"
                        >
                          24 Jam
                        </b-form-checkbox>
                      </b-col>
                    </b-row>
                    <div v-show="!day.fullDay">
                      <b-row class="flex-col md:flex-row">
                        <b-col class="mb-2 md:mb-0">
                          <span class="mb-2 block">Jam Mulai</span>
                          <div class="flex gap-[6px]">
                            <div class="border flex-1 flex items-center justify-center rounded-md">
                              <flat-pickr
                                v-model="day.start"
                                name="time-start"
                                :config="configDate"
                                class="!border-0 !p-[8px] !w-full text-center"
                              />
                            </div>
                            <div class="">
                              <b-icon-chevron-up
                                role="button"
                                @click="setTime('plus', 'start', day)"
                              /><br>
                              <b-icon-chevron-down
                                role="button"
                                @click="setTime('minus', 'start', day)"
                              />
                            </div>
                          </div>
                        </b-col>
                        <b-col>
                          <span class="mb-2 block">Jam Akhir</span>
                          <div class="flex gap-[6px]">
                            <div class="border flex-1 flex items-center justify-center rounded-md">
                              <flat-pickr
                                v-model="day.end"
                                name="time-end"
                                :config="configDate"
                                class="!border-0 !p-[8px] !w-full text-center"
                              />
                            </div>
                            <div>
                              <b-icon-chevron-up
                                role="button"
                                @click="setTime('plus', 'end', day)"
                              /><br>
                              <b-icon-chevron-down
                                role="button"
                                @click="setTime('minus', 'end', day)"
                              />
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            id="switch 3"
            class="mt-3"
            label="Ekspedisi"
            label-for="switch"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <template #label>
              <div>
                Follow Up Order <b-icon
                  :id="`info-follow-up-order`"
                  class="!text-[#08A0F7]"
                  icon="info-circle"
                />
                <b-popover
                  :target="`info-follow-up-order`"
                  placement="top"
                  triggers="hover focus"
                >
                  CS AI akan mengirim follow up otomatis saat order mendekati close namun belum terselesaikan.
                </b-popover>
              </div>
            </template>
            <div class="border p-1 rounded-md mt-1">
              <div
                class="flex  items-center  justify-between"
              >
                <div class="flex gap-1">

                  <div>Follow Up Order</div>
                </div>
                <b-form-checkbox
                  id="`checkbox-eks${index}`"
                  v-model="followUpOrder"
                  switch
                />
              </div>
              <div
                v-show="followUpOrder"
                class="pr-1 mt-1"
              >
                <div
                  v-for="item in reminder"
                  :key="item.id"
                >
                  <div class="flex mb-1 items-center justify-between">
                    <b-form-checkbox
                      :id="`checkbox-follow-up-order-${item.id}`"
                      :checked="item.isActive"
                      name="checkbox-follow-up-order"
                      @change="onToggleReminderActive(item)"
                    >
                      {{ item.label }}
                    </b-form-checkbox>
                    <div role="button">
                      <b-icon
                        scale="1.5"
                        :icon="item.isOpenEdit ? 'chevron-up' : 'chevron-down'"
                        @click=" item.isOpenEdit = !item.isOpenEdit"
                      />
                    </div>
                  </div>
                  <div v-show="item.isOpenEdit">
                    <b-form-group
                      id="input-group-5"
                      label="Text Follow Up Order"
                      label-for="textarea-small"
                    >
                      <template #label>
                        <div class="flex justify-between items-center">
                          <div class="text-base">
                            Pesan Follow Up
                          </div>
                          <div class="flex gap-2">
                            <b-button
                              id="popover-target-1"
                              variant="outline"
                              size="sm"
                              class="!w-fit !p-1 !border-[#E2E2E2]"
                              @click="onResetMessageFollowUpOrder(item)"
                            >
                              <b-img
                                width="13"
                                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/refresh-2.svg"
                              />
                            </b-button>
                            <b-popover
                              target="popover-target-1"
                              triggers="hover"
                              placement="top"
                              custom-class="custom-popover"
                            >
                              <div>
                                Reset
                              </div>
                            </b-popover>
                            <b-button
                              :variant="item.onEdit?'primary':'outline'"
                              size="sm"
                              class="!p-1 !border-[#E2E2E2]"
                              @click="onToggleEditMessage(item)"
                            >
                              {{ item.onEdit? 'Simpan': 'Edit' }}
                            </b-button>
                          </div>
                        </div>
                      </template>
                      <b-form-textarea
                        id="textarea-small"
                        v-model="item.message"
                        maxlength="300"
                        :disabled="!item.onEdit"
                        class="min-h-[108px] resize-y"
                        placeholder="Masukkan text follow up order"
                        @input="onTextFollowUpOrder(item, $event)"
                      />
                      <div class="text-end text-sm text-[#999999]">
                        <span>
                          {{ item.message.length || 0 }} / 300
                        </span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
          <b-form-group
            id="switch 3"
            class="mt-3"
            label="Notifikasi Email"
            label-for="switch"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <template #label>
              <div>
                Notifikasi Email <b-icon
                  :id="`info-notifikasi-email`"
                  class="!text-[#08A0F7]"
                  icon="info-circle"
                />
                <b-popover
                  :target="`info-notifikasi-email`"
                  placement="top"
                  triggers="hover focus"
                >
                  Kirim email otomatis ke partner setiap kali order berhasil di-closing dan pembayaran telah dikonfirmasi.
                </b-popover>
              </div>
            </template>
            <div class="border p-1 rounded-md mt-1">
              <div
                class="flex  items-center  justify-between"
              >
                <div class="flex gap-1">
                  <div>Notifikasi Email Close Order</div>
                </div>
                <b-form-checkbox
                  id="checkbox-email-close-order"
                  v-model="formData.email_close_order"
                  switch
                />
              </div>
            </div>
          </b-form-group>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-form-group
            id="switch 2"
            class="mt-3"
            label="Pembayaran"
            label-for="some-radios"
            label-class="mb-2 text-[14px] font-medium  leading-none tracking-normal align-middle text-[#333333] "
          >
            <div>
              <div class="border p-1 rounded-md">
                <div class="mb-1">
                  COD
                </div>
                <div class="border p-1 rounded-md">
                  <b-form-radio
                    :checked="isCodSelected"
                    name="cod-radio"
                    :value="true"
                    @click.native.prevent="togglePaymentMethod('COD', !isCodSelected)"
                  >
                    Bayar Ditempat (COD)
                  </b-form-radio>
                </div>
              </div>
              <div class="border mt-2  p-1 rounded-md">
                <div class="mb-1 flex items-center justify-between">
                  <div>Non COD</div>
                  <div
                    :id="`info-non-cod`"
                    class="!text-[#08A0F7]"
                    icon="info-circle"
                  >
                    <a
                      href="https://bantuan.komerce.id/id/article/informasi-pemotongan-biaya-pada-transaksi-jenis-pembayaran-non-cod-komchat-ai-ee1wvf/"
                      target="_blank"
                      class="underline underline-offset-4 !text-primary"
                    >
                      Skema Biaya
                    </a>
                  </div>
                  <b-popover
                    :target="`info-non-cod`"
                    placement="top"
                    triggers="hover"
                  >
                    Informasi potongan biaya untuk pembayaran Non-COD akan dipotong otomatis dari transaksi. Klik untuk detailnya.
                  </b-popover>
                </div>
                <div class="border  p-1 rounded-md ">
                  <div class="flex items-center justify-between">
                    <b-form-radio
                      :checked="nonCodSelection"
                      name="bank-transfer-radio"
                      value="BANK_TRANSFER"
                      @click.native.prevent="toggleNonCod('BANK_TRANSFER')"
                    >
                      Transfer Bank
                    </b-form-radio>
                  </div>
                  <div
                    v-show="!bankAccount.length"
                    class="border  mt-1 p-1 rounded-md"
                  >
                    <div class=" gap-2 grid justify-center">
                      <div class="flex justify-center">
                        <div class="border w-[23px] flex justify-center p-[5px] min-w-fit rounded-md ">
                          <b-img
                            width="20"
                            src="https://storage.googleapis.com/komerce/assets/icons/search-abu.svg"
                          />
                        </div>
                      </div>
                      <div class="text-[#333333]">
                        Belum ada data rekening
                      </div>
                      <div class="text-sm">
                        Tambahkan rekening kamu
                      </div>
                    </div>
                  </div>

                  <div
                    v-show="bankAccount.length"
                    class="border mt-1 p-1 rounded-md"
                  >
                    <div
                      v-for="(item, index) in bankAccount"
                      :key="index"
                      class="grid grid-cols-7 mt-1 gap-1 items-center"
                    >
                      <div class="flex col-span-6 items-center justify-between">
                        <div class="flex gap-1 items-center">
                          <div>
                            <span>{{ item.bank_name }}</span> - <span>{{ item.account_no }}</span><span v-show="item.account_name">({{ item.account_name }})</span> </div>
                          <img
                            :src="item.type !== 1 ? 'https://storage.googleapis.com/komerce/assets/icons/verified.svg': 'https://storage.googleapis.com/komerce/assets/LP-Komerce/komchat.svg'"
                            alt=""
                          >
                        </div>
                        <div>
                          <b-button
                            v-show="item.type === 1"
                            class=" !p-1"
                            variant="outline-primary"
                            :disabled="onAddBank"
                            size="sm"
                            @click="addBank(item)"
                          >Edit</b-button>
                        </div>
                      </div>
                      <div class="text-end">
                        <b-form-checkbox
                          :id="`checkbox-bank${index}`"
                          v-model="formData.bank_account_ids"
                          :disabled="!formData.payment_method.includes('BANK_TRANSFER')"
                          class="!p-1"
                          variant="outline-primary"
                          size="md"
                          :value="item.bank_account_id"
                          switch
                        />
                      </div>

                    </div>
                  </div>
                  <b-button
                    class="rounded-md mt-1 !p-1"
                    variant="outline-primary"
                    size="sm"
                    :disabled="onAddBank"
                    @click="addBank"
                  >
                    <b-icon
                      icon="plus"
                    />
                    Tambah Rekening
                  </b-button>
                  <AddBankAccount
                    v-show="onAddBank"
                    :account-number="accountNumber"
                    :bank-name="bankName"
                    :id-bank="idBank"
                    @refresh="getBankAccountData"
                    @addBank="addBank"
                  />

                </div>
                <div class="border p-1 mt-2 rounded-md">
                  <b-form-radio
                    :checked="nonCodSelection"
                    name="komerce-payment-radio"
                    value="KOMERCE"
                    :disabled="hasInvalidPrice"
                    @click.native.prevent="toggleNonCod('KOMERCE')"
                  >
                    <div class="flex gap-1">
                      Metode Pembayaran Komerce <span>
                        <img
                          id="popover-payment-komerce"
                          class="cursor-pointer w-[20px]"
                          src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/info-circle.svg"
                        >
                      </span>
                      <b-popover
                        target="popover-payment-komerce"
                        triggers="hover"
                        placement="top"
                        custom-class="custom-popover text-xs"
                      >
                        Pembayaran dilakukan melalui Virtual Account (VA) atau QRIS, dan akan masuk ke saldo Kompay Anda.
                      </b-popover>
                    </div>
                  </b-form-radio>
                </div>
                <div
                  v-show="hasInvalidPrice"
                  class="flex mt-1 bg-[#FFF2E2] gap-2 border border-2 rounded-md p-1 border-[#FBA63C] text-[#FBA63C]"
                >
                  <div>
                    <b-icon
                      scale="1"
                      icon="exclamation-triangle"
                      variant="warning"
                    />
                  </div>
                  <div>
                    Produk Anda {{ invalidPriceProducts.join(', ') }} tidak memenuhi syarat minimum transaksi sebesar Rp 10.000. Anda tidak dapat melanjutkan pembayaran menggunakan metode ini.
                  </div>
                </div>
              </div>
            </div>
          </b-form-group>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import VSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import AddBankAccount from './AddBankAccount.vue'
import { apiGetBankAccount } from './service/api.bankAccount.service'
import apiGetShipment from './service/api.shipment.service'
import apiGetWhatsAppList from './service/api.whatsApp.service'
import { days, followUporderDefault, followUporder } from './config'
import 'flatpickr/dist/themes/light.css'
// eslint-disable-next-line import/order
import { Indonesian } from 'flatpickr/dist/l10n/id'

export default {
  components: {
    VSelect,
    AddBankAccount,
    flatPickr,
  },
  props: {
    formData: {
      type: Object,
      default: () => ({
        phone_number: null,
        is_off_when_manually: false,
        times: [],
        payment_method: ['COD'],
        bank_account_ids: [],
        bank_accounts: [],
        reminder: [],
        email_close_order: false,
      }),
    },
    hasInvalidPrice: {
      type: Boolean,
      default: false,
    },
    invalidPriceProducts: {
      type: Array,
      default: () => [],
    },
    bankAccounts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      numberOptions: [],
      setCsTime: false,
      showDayDropdown: false,
      whatsAppList: [],
      shipment: [],
      selectedDays: [],
      onAddBank: false,
      bankAccount: [],
      accountNumber: '',
      idBank: '',
      bankName: '',
      days,
      configDate: {
        dateFormat: 'H:i',
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        allowInput: true,
        static: true,
        wrap: false,
        clickOpens: false,
        locale: Indonesian,
        altInputClass: 'bg-white form-control',
      },
      followUpOrder: false,
      followUporderDefault,
      reminderData: [],
    }
  },
  computed: {
    formattedSelectedDaysText() {
      if (!this.selectedDays || this.selectedDays.length === 0) {
        return '' // Akan menampilkan placeholder 'Pilih Hari' dari template
      }
      // Jika "Setiap Hari" dipilih, tampilkan hanya "Setiap Hari"
      if (this.selectedDays.some(d => d.name === 'Setiap Hari')) {
        return 'Setiap Hari'
      }
      // Jika tidak, gabungkan nama hari-hari yang dipilih
      return this.selectedDays.map(item => item.name).join(', ')
    },
    reminder() {
      return this.reminderData
    },
    isCodSelected() {
      if (!Array.isArray(this.formData.payment_method)) return false
      return this.formData.payment_method.includes('COD')
    },
    nonCodSelection: {
      get() {
        if (!Array.isArray(this.formData.payment_method)) return null
        return this.formData.payment_method.find(m => ['BANK_TRANSFER', 'KOMERCE'].includes(m)) || null
      },
      set(val) {
        let methods = []
        if (Array.isArray(this.formData.payment_method)) {
          methods = [...this.formData.payment_method]
        } else if (this.formData.payment_method) {
          methods = [this.formData.payment_method]
        }

        // Remove existing non-cod methods
        methods = methods.filter(m => !['BANK_TRANSFER', 'KOMERCE'].includes(m))
        // Add new method if valid
        if (val) {
          methods.push(val)
        }
        this.formData.payment_method = methods
      },
    },
  },
  watch: {
    'formData.times': {
      immediate: true,
      handler(newTimes) {
        // Hindari pemrosesan jika tidak ada data atau dalam proses update
        if (!newTimes || !Array.isArray(newTimes)) return

        // Hanya set jika belum diset dan ada data
        if (newTimes.length > 0 && !this.setCsTime) {
          this.setCsTime = true

          // Konversi data times dengan validasi
          const convertedDays = newTimes.map(time => {
            if (!time || !time.day_of_week) return null

            const dayObject = this.days.find(d => d.value === time.day_of_week)
            if (!dayObject) return null

            return {
              ...dayObject,
              fullDay: time.is_24_hours
                      || (time.start_time === '00:00:00' && time.end_time === '23:59:00'),
              start: time.start_time ? time.start_time.substring(0, 5) : '00:00',
              end: time.end_time ? time.end_time.substring(0, 5) : '23:59',
            }
          }).filter(Boolean)

          // Update selectedDays hanya jika ada perubahan
          if (convertedDays.length > 0) {
            this.selectedDays = convertedDays
          }
        }
      },
    },
    selectedDays: {
      handler() {
        this.prepareSchedulesForForm()
      },
      deep: true,
    },
    setCsTime(isSet) {
      if (!isSet) {
        this.selectedDays = []
      }
      this.prepareSchedulesForForm()
    },
    'formData.payment_method': { // Corrected watcher for formData.payment_method
      handler(newVal) {
        const methods = Array.isArray(newVal) ? newVal : []
        if (methods.includes('BANK_TRANSFER')) {
          this.formData.bank_account_ids = this.bankAccounts.map(item => item.bank_account_id) || []
        }
      },
      deep: true,
    },
    'formData.reminder': {
      immediate: true,
      handler(newReminder) {
        this.updateReminderData(newReminder)
      },
    },
    followUpOrder(isActive) {
      if (isActive) {
        if (!Array.isArray(this.reminderData) || this.reminderData.length === 0) {
          this.reminderData = followUporderDefault.map(item => ({ ...item }))
        } else if (!this.reminderData.some(item => item.isActive)) {
          this.reminderData = this.reminderData.map(item => ({
            ...item,
            isActive: true,
          }))
        }
        this.updateFormDataReminder()
      } else {
        this.reminderData = this.reminderData.map(item => ({
          ...item,
          isActive: false,
          onEdit: false,
          isOpenEdit: false,
        }))
        this.formData.reminder = []
      }
    },
  },
  mounted() {
    if (this.formData.payment_method && !Array.isArray(this.formData.payment_method)) {
      this.formData.payment_method = [this.formData.payment_method]
    }
    this.fetchInitialData()
  },
  methods: {
    async fetchInitialData() {
      // await this.getShipmentData()
      await this.getBankAccountData()
      await this.getListNumber()
    },
    togglePaymentMethod(methodName, isChecked) {
      let methods = []
      if (Array.isArray(this.formData.payment_method)) {
        methods = [...this.formData.payment_method]
      } else if (this.formData.payment_method) {
        methods = [this.formData.payment_method]
      }

      if (isChecked) {
        // Add method if not exists
        if (!methods.includes(methodName)) {
          methods.push(methodName)
        }
      } else {
        // Remove method
        methods = methods.filter(m => m !== methodName)
      }
      this.formData.payment_method = methods
    },
    toggleNonCod(value) {
      if (value === 'KOMERCE' && this.hasInvalidPrice) return

      let methods = []
      if (Array.isArray(this.formData.payment_method)) {
        methods = [...this.formData.payment_method]
      } else if (this.formData.payment_method) {
        methods = [this.formData.payment_method]
      }

      const isSelected = methods.includes(value)

      // Remove both non-cod options to ensure mutual exclusion
      methods = methods.filter(m => !['BANK_TRANSFER', 'KOMERCE'].includes(m))

      // If it wasn't selected before, add it (toggle on)
      if (!isSelected) {
        methods.push(value)
      }

      this.$set(this.formData, 'payment_method', methods)
    },
    toggleDayDropdown() {
      this.showDayDropdown = !this.showDayDropdown
    },
    isDaySelected(day) {
      return this.selectedDays.some(selected => selected.id === day.id)
    },
    isDayOptionDisabled(day) {
      // Menonaktifkan hari individual jika "Setiap Hari" dipilih,
      // kecuali hari itu sendiri adalah "Setiap Hari".
      const setiapHariIsSelected = this.selectedDays.some(d => d.name === 'Setiap Hari')
      return setiapHariIsSelected && day.name !== 'Setiap Hari'
    },
    selectDay(day) {
      if (this.isDayOptionDisabled(day) && !this.isDaySelected(day)) {
        return
      }

      const everyDayObject = this.days.find(d => d.name === 'Setiap Hari')
      const allDays = this.days.filter(d => d.name !== 'Setiap Hari')
      let newSelectedDays = [...this.selectedDays]

      if (day.name === 'Setiap Hari') {
        if (this.isDaySelected(day)) {
          newSelectedDays = []
        } else {
          // Pilih semua hari Senin-Minggu dengan waktu default 00:00-23:59 dan fullDay true
          newSelectedDays = allDays.map(d => ({
            ...d,
            fullDay: true,
            start: '00:00',
            end: '23:59',
          }))
        }
      } else {
        const isEveryDaySelected = allDays.every(d => newSelectedDays.some(sel => sel.id === d.id && sel.fullDay && sel.start === '00:00' && sel.end === '23:59'))
        if (isEveryDaySelected) {
          // Jika semua hari sudah terpilih fullDay, hapus "Setiap Hari" dan toggle hari yang diklik
          newSelectedDays = []
        }
        const index = newSelectedDays.findIndex(selected => selected.id === day.id)
        if (index > -1) {
          newSelectedDays.splice(index, 1)
        } else {
          newSelectedDays.push({
            ...day,
            fullDay: true,
            start: '00:00',
            end: '23:59',
          })
        }
      }
      this.selectedDays = newSelectedDays
    },
    prepareSchedulesForForm() {
      if (!this.setCsTime || !Array.isArray(this.selectedDays)) {
        this.formData.times = []
        return
      }

      this.formData.times = this.selectedDays
        .filter(dayObj => dayObj && dayObj.value) // Validasi data
        .map(dayObj => ({
          day_of_week: dayObj.value,
          is_24_hours: !!dayObj.fullDay,
          start_time: dayObj.fullDay ? '00:00' : (dayObj.start || '00:00'),
          end_time: dayObj.fullDay ? '23:59' : (dayObj.end || '23:59'),
        }))
    },
    async getShipmentData() {
      try {
        const { data } = await apiGetShipment()
        this.shipment = data.data || []
      } catch (error) {
        this.$toast_error({ message: 'Gagal mengambil data Expedisi' })
        this.shipment = []
      }
    },
    async getBankAccountData() {
      try {
        const { data } = await apiGetBankAccount()
        this.bankAccount = data.data || []
      } catch {
        this.bankAccount = []
        this.$toast_error({ message: 'Gagal mengambil data bank account' })
      // Tambahkan notifikasi error ke pengguna jika perlu
      }
    },
    addBank(item = null) {
      if (item && item.bank_account_id) { // Mode Edit
        this.accountNumber = item.account_no
        this.bankName = item.bank_name
        this.idBank = item.bank_account_id
      } else { // Mode Tambah Baru
      // this.itemBank = null;
        this.accountNumber = ''
        this.bankName = ''
      }
      this.onAddBank = !this.onAddBank // Toggle tampilan form AddBankAccount
    },
    async getListNumber() {
      try {
        const { data } = await apiGetWhatsAppList()
        this.numberOptions = data.data || []
      } catch {
        this.$toast_error({ message: 'Gagal mengambil data nomor whatsapp' })
      }
    },
    setTime(action, type, day) {
      const time = day[type] || '00:00'
      const [hours, minutes] = time.split(':').map(Number)

      let newHours = hours
      if (action === 'plus') {
        newHours = (hours + 1) % 24
      } else if (action === 'minus') {
        newHours = (hours - 1 + 24) % 24
      }

      const updatedDay = { ...day }
      updatedDay[type] = `${String(newHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
      Object.assign(day, updatedDay)
    },
    onToggleReminderActive(item) {
      this.$set(item, 'isActive', !item.isActive)
      this.updateFormDataReminder()
    },
    updateFormDataReminder() {
      const activeReminders = this.reminderData
        .filter(item => item.isActive)
        .map(item => ({
          delay: item.delay,
          message: item.message,
        }))

      this.formData.reminder = activeReminders
    },
    updateReminderData(newReminder) {
      if (!newReminder || newReminder.length === 0) {
        this.reminderData = followUporderDefault.map(item => ({ ...item }))
        this.followUpOrder = false
        return
      }

      const reminders = followUporderDefault.map(item => {
        const reminder = newReminder.find(r => r.delay === item.delay)
        if (reminder) {
          this.followUpOrder = true
          return {
            ...item,
            isActive: true,
            message: reminder.message || '',
          }
        }
        return {
          ...item,
          isActive: false,
          onEdit: false,
          isOpenEdit: false,
        }
      })

      this.reminderData = reminders
    },
    onResetMessageFollowUpOrder(item) {
      this.reminderData.find(r => r.id === item.id).message = followUporder.find(r => r.id === item.id).message
      this.updateFormDataReminder()
    },
    onTextFollowUpOrder(item, event) {
      this.reminderData.find(r => r.id === item.id).message = event
    },
    onToggleEditMessage(item) {
      this.$set(item, 'onEdit', !item.onEdit)
      if (!item.onEdit) {
        this.updateFormDataReminder()
      }
    },
  },

}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';

.custom-day-select-trigger {
  cursor: pointer;
}

.custom-day-select-dropdown {
  max-height: 200px; /* Atur tinggi maksimal dropdown */
  overflow-y: auto;
}

.custom-day-select-option {
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.custom-day-select-option.active-day-option {
  background-color: #FDECEC;
  color: #E53E3E;
}

.custom-day-select-option.disabled-day-option {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}

.custom-day-select-option.setiap-hari-option.active-day-option {
   background-color: #FDECEC;
   color: #E53E3E;
}

</style>
